import { optionalUuidString } from '../zod-helpers/index.js';
import { lowercaseUuid } from './lowercase-uuid.js';
/** A promotion select: an empty selection means no promotion, so it reads as null rather than reaching the uuid column. */
export const promotionLinkInput = optionalUuidString('Invalid promotion selection.')
    .nullish()
    .transform((value) => {
    if (typeof value !== 'string')
        return value;
    return value.trim() === '' ? null : lowercaseUuid(value);
});
//# sourceMappingURL=promotion-link-input.js.map